module.exports = __webpack_public_path__ + "img/tech 5.b29efbb8.png";